// extracted by mini-css-extract-plugin
module.exports = {"disabled":"dJFNqcYd_1QjmzRj6JJU","label":"RZtZ4pWz_jQK3rjjpQkD","span":"cNV8nPKFI1ZVPyuNqKi8"};